import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Experience from './Experience';
import Contact from './Contact';
import Footer from './Footer';

function Home() {
  const location = useLocation();

  useEffect(() => {
    // Handle hash navigation when component mounts or hash changes
    const handleHashNavigation = () => {
      const hash = location.hash.replace('#', '');
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      } else {
        // Scroll to top if no hash
        window.scrollTo(0, 0);
      }
    };

    handleHashNavigation();
  }, [location.hash]);

  return (
    <>
      <section id="home">
        <Hero />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="experience">
        <Experience />
      </section>

      <section id="contact">
        <Contact />
      </section>

      <Footer />
    </>
  );
}

export default Home;
